import { Grid, useMediaQuery } from "@mui/material";
import { Labeled, ReferenceField, SelectField, TextField } from "react-admin";

import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { SectionTitle } from "features/SectionTitle";
import { GenderOptionsId } from "utils/choices";

const NAME_FIELDS = [
  { source: "userInfo.firstName", label: "Име" },
  { source: "userInfo.lastName", label: "Фамилия" },
  { source: "userInfo.firstNameLatin", label: "Име (латиница)" },
  { source: "userInfo.lastNameLatin", label: "Фамилия (латиница)" },
];

const PersonalDataSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <>
      <SectionTitle
        paddingY={2}
        title="Лични данни"
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        {NAME_FIELDS.map(({ source, label }) => (
          <Grid
            item
            xs={12}
            md={3}
            key={source}
          >
            <Labeled label={label}>
              <TextField
                source={source}
                emptyText="-"
              />
            </Labeled>
          </Grid>
        ))}
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Пол">
            <SelectField
              source="userInfo.gender"
              choices={GenderOptionsId}
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Гражданство">
            <ReferenceField
              source="userInfo.citizenship"
              reference={administrationRequests.getCitizenshipSelect()}
              emptyText="-"
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
      </Grid>
    </>
  );
};

export default PersonalDataSection;
